import { useMemo } from 'react';
import { Item } from '../../../types/interfaces';
import { getPriceInRange } from '../lib/getPriceInRange';

interface UsePriceInRangeParams {
  product: Item;
  inputValue: number;
}

export const usePriceInRange = ({ product, inputValue }: UsePriceInRangeParams) => {
  return useMemo(
    () => getPriceInRange(product, Number(inputValue))?.price,
    [product, inputValue]
  );
};
